import React from 'react';
import { useApp } from '../context/AppContext';

export default function RosterPage() {
  const { theme, currentUser } = useApp();

  // Build iframe URL — pass auth context from main app so calendar never asks for login
  const params = new URLSearchParams({ theme });
  if (currentUser?.role === 'viewer' && currentUser?.team) {
    params.set('teamLock', currentUser.team);
  } else if (currentUser?.login) {
    params.set('autoLogin', currentUser.login);
  }

  return (
    <iframe
      key={theme + (currentUser?.login || currentUser?.team || '')}
      src={`/roster-calendar.html?${params.toString()}`}
      title="Leave Calendar"
      style={{ display: 'block', width: '100%', height: '100vh', border: 'none' }}
    />
  );
}
